import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal } from "@mui/material";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SlidingPanel from "react-sliding-side-panel";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
  table_data: Array<{
    id: Number;
    sr_no: Number;
    category_name: string;
    description: string;
    action_btns: string;
    deleteable: boolean;
  }>;
}

const AddCategory: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
  table_data,
}) => {
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [addCategoryStep, setAddCategoryStep] = useState<
    Array<{
      id: Number;
      sr_no: Number;
      category_name: string;
      description: string;
      action_btns: string;
      deleteable: boolean;
    }>
  >([
    {
      id: Math.random(),
      sr_no: 0,
      category_name: "",
      description: "",
      action_btns: "Edit",
      deleteable: false,
    },
  ]);

  const updateMasterStateArray = (attrName: any, value: any) => {
    const array_data = [...addCategoryStep];
    if (attrName[1] === "category_name") {
      array_data[attrName[0]].category_name = value;
    } else if (attrName[1] === "description") {
      array_data[attrName[0]].description = value;
    }

    setAddCategoryStep(array_data);
  };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      // backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center" className="mt-0">
          <Grid xs={10}>
            <h4 className="mb-0">Add New Category</h4>
          </Grid>
          <Grid xs={2} textAlign="end">
            <GridCloseIcon
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
          <Grid xs={12} className="text-right">
            <Link
              className="greenBtn addfile ml-0"
              underline="none"
              onClick={() => {
                setAddCategoryStep((addCategoryStep) => [
                  ...addCategoryStep,
                  {
                    id: Math.random(),
                    sr_no: 0,
                    category_name: "",
                    description: "",
                    action_btns: "Edit",
                    deleteable: true,
                  },
                ]);
              }}
            >
              Add More
            </Link>
          </Grid>
          <Grid xs={12}>
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          {addCategoryStep.map((data, index) => (
            <Grid container spacing={3}>
              <Grid xs={9}>
                <p className="labelTitle">{index + 1}. Category</p>
              </Grid>
              {data.deleteable == false ? null : (
                <Grid xs={3} className="text-right">
                  <Link
                    className="redBtn delete ml-0"
                    underline="none"
                    onClick={() => {
                      setAddCategoryStep((addCategoryStep) =>
                        addCategoryStep.filter((_, i) => i !== index)
                      );
                    }}
                  >
                    Remove
                  </Link>
                </Grid>
              )}
              <Grid xs={8}>
                <RKTextField
                  class_name="inputField"
                  title={"Category Name"}
                  value={data.category_name}
                  attrName={[index, "category_name"]}
                  value_update={updateMasterStateArray}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField"
                  title={"Description"}
                  value={data.description}
                  attrName={[index, "description"]}
                  value_update={updateMasterStateArray}
                  warn_status={false}
                />
              </Grid>
            </Grid>
          ))}
        </div>
        {pageStatus !== 4 ? (
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  setPageStatus(pageStatus + 1);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        ) : null}
      </div>
    </SlidingPanel>
  );
};

export default AddCategory;
